import { useState } from 'react';
import { Expand } from 'lucide-react';
import { WhiteboardCanvas } from './whiteboardShapes';
import { WhiteboardFullscreen } from './WhiteboardFullscreen';

// Read-only renderer used by the preview, presentation and public views (+ read-only full-screen viewer).
export function WhiteboardView({ block }) {
  const c = block.content || {};
  const [full, setFull] = useState(false);
  return (
    <div data-testid="whiteboard-view" className="w-full">
      {c.title && <h3 className="font-serif text-2xl sm:text-3xl text-slate-800 tracking-tight mb-4 text-center">{c.title}</h3>}
      <div className="w-full rounded-xl border border-slate-200 overflow-hidden shadow-sm" style={{ backgroundColor: c.background || '#FFFFFF' }}>
        <WhiteboardCanvas content={c} />
      </div>
      <div className="flex justify-end mt-2">
        <button type="button" onClick={() => setFull(true)} data-testid="wb-expand" aria-label="Open full screen" title="Open full screen"
          className="h-11 px-4 inline-flex items-center gap-1.5 rounded-full bg-slate-900 text-white text-xs font-medium hover:bg-slate-700 transition-colors">
          <Expand className="h-4 w-4" />Full screen
        </button>
      </div>
      {full && <WhiteboardFullscreen content={c} onClose={() => setFull(false)} />}
    </div>
  );
}
